import { render, staticRenderFns } from "./ToolCertificationChip.vue?vue&type=template&id=37dd4cad&scoped=true"
import script from "./ToolCertificationChip.vue?vue&type=script&lang=ts"
export * from "./ToolCertificationChip.vue?vue&type=script&lang=ts"
import style0 from "./ToolCertificationChip.vue?vue&type=style&index=0&id=37dd4cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd4cad",
  null
  
)

export default component.exports